import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { isInBrowser, baseUrl } from "services/shared/Environment";
import { currentUserIdToken } from "services/browser/FirebaseWeb";
import fetch from "isomorphic-unfetch";

let apolloClient = null;

export function initializeApolloClient(initialState?: any) {
  // Make sure to create a new client for every server-side request so that data
  // isn't shared between connections (which would be bad)
  if (isInBrowser()) {
    return createApolloClient(initialState);
  }

  // Reuse client on the client-side
  if (!apolloClient) {
    apolloClient = createApolloClient(initialState);
  }

  return apolloClient;
}

export function getApiUrl() {
  return `${baseUrl()}/api/graphql`;
}

function getLink() {
  return getAuthLink().concat(getHttpLink());
}

function getAuthLink() {
  return setContext(async (_, { headers }) => {
    let token = "";
    if (isInBrowser()) {
      token = await currentUserIdToken();
    }

    return {
      headers: {
        ...headers,
        authorization: token
      }
    };
  });
}

function getHttpLink() {
  return createHttpLink({
    uri: getApiUrl(),
    credentials: "same-origin", // Additional fetch() options like `credentials` or `headers`
    fetch
  });
}

export function createApolloClient(initialState = {}) {
  return new ApolloClient({
    ssrMode: isInBrowser(), // Disables forceFetch on the server (so queries are only run once)
    link: getLink(),
    cache: new InMemoryCache().restore(initialState),
    resolvers: {}
  });
}
